import LogCannon from '@ace-clublabs/log-cannon';
import axios from 'axios';
import StatusCode from 'status-code-enum';
import CookieHelper from '../../utils/cookieHelper';
import { GetTransactionStatus } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const GetTransactionStatusApi =
  (endpoint: string): GetTransactionStatus =>
  async (id: string) => {
    try {
      LogCannon.blast('GetTransactionStatusApi start', {
        endpoint,
        transactionId: id,
      });
      const url = endpoint.replace('{id}', id);
      const scenario = CookieHelper.getCookie('scenario');
      const config = createAxiosConfig(scenario, endpoint);
      const response = await axios.get(url, config);
      LogCannon.blast('GetTransactionStatusApi success');
      const { status, message, freedomPayReasonCode, code } = response?.data || {};
      return Promise.resolve({
        statusCode: response?.status,
        transactionStatus: status,
        message,
        freedomPayReasonCode,
        code,
      });
    } catch (error: any) {
      LogCannon.error('GetTransactionStatusApi error', { error });
      const statusCode = error.response?.status || error.status || StatusCode.ServerErrorInternal;
      return Promise.reject({ statusCode });
    }
  };
